// extracted by mini-css-extract-plugin
module.exports = {"logo":"_7a3fb80146--logo--chwPf","link":"_7a3fb80146--link--MrOJj","label":"_7a3fb80146--label--eFiNz"};